export default "__VITE_ASSET__DX4WnQ4F__"